import { useEffect, useState } from "react";
import styles from "./EnterpriseList.module.css";
import useNotification from "../../../hooks/useNotification";
import DashboardServices from "../../../services/DashboardServices";
import EnterpriseDataTable from "./EnterpriseDataTable";
import ActiveJobOverview from "./ActiveJobOverview";
import ActiveJobsListing from "./ActiveJobsListing";
import DurationPicker from "../../CommonComponents/InputControls/DurationPicker";
import DateRangePicker from "../../CommonComponents/InputControls/DateRangePicker";

const EnterpriseList = () => {
  const { showNotification } = useNotification();
  const [loading, setLoading] = useState(false);
  const [jobsData, setJobsData] = useState({});

  useEffect(() => {
    const fetchUserOverviewData = async () => {
      const res = await DashboardServices.getUsersOverview();

      if (res) {
        if (res.statusCode === 1) {
          setJobsData(res.data);
        } else {
          handleError(`${res.statusDesc}`);
        }
      } else {
        handleError(`Error: ${res.statusDesc}`);
      }
    };
    fetchUserOverviewData();
  }, []);

  const handleError = (error) => {
    setLoading(false);
    showNotification(error, "error");
  };

  return (
    <div className={styles.page_wrap}>
      <div className={styles.title}>Enterprises</div>
      <div>
        <EnterpriseDataTable />
        <div className={styles.date_selection}>
          <DurationPicker />
          <DateRangePicker />
        </div>
        <ActiveJobOverview data={jobsData} />
        <ActiveJobsListing />
      </div>
    </div>
  );
};

export default EnterpriseList;
